import { Backdrop } from "@mui/material";
import Offcanvas from 'react-bootstrap/Offcanvas'
import { toast } from 'react-toastify';

const AddStock = ({ show, setShow, inventoryId, updateStock, handleChange, stockForm,action }) => {

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     updateStock();
    // }
    // const handleClose = () => {
    //     setShow(false);
    // }

        const handleSubmit = (e) => {
        e.preventDefault();
        // Validation: Check if quantity is empty or zero
        if (!stockForm.quantity || stockForm.quantity <= 0) {
            toast.error("Please enter a valid quantity greater than zero.");
            return;
        }
        updateStock();
    }
    const handleClose = () => {
        setShow(false);
    }

    return (
        <>
            <Backdrop open={show} onClick={handleClose} >
                <Offcanvas show={show} onHide={handleClose} onClick={(e) => e.stopPropagation()} placement="end" backdrop={false}>
                    <div style={{ padding: '10px' }}>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                            onClick={() => {
                                setShow(false)
                            }}
                        ></button>
                        <h1 className="popupheader text-center heading-color " id="offcanvasRightLabel">
                             {action === 'ADD' ? 'Add Stock' : 'Release Stock'}
                        </h1>
                    </div>
                    <div className="offcanvas-body">
                        <form className="cus-form" onSubmit={handleSubmit} >
                            <div className="mb-3">
                                <input 
                                    type="number"
                                    name="quantity"
                                    placeholder="Stock Quantity"
                                    className='form-control alreadytext'
                                    onChange={handleChange}
                                    value={stockForm.quantity}
                                    maxLength={4}
                                    min={1}
                                />
                            </div>
                            <div className="d-grid  col-6 mx-auto mb-3">
                                <button className="btn colorbtun popupbtn px" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </Offcanvas>
            </Backdrop>
        </>
    )
}

export default AddStock;